/**
 * 對話頁面載入指示器
 * 顯示載入中的指示器
 */
export function ConversationLoadingModal({
  isLoading,
}: {
  isLoading: boolean;
}) {
  return (
    <>
      {isLoading && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-full p-4 shadow-lg z-50">
          <div className="flex items-center space-x-3">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#6B8E5A]"></div>
            <span className="text-[#A0956B] text-sm">AI 思考中...</span>
          </div>
        </div>
      )}
    </>
  );
}
